import React, { useState } from "react";
import withRouter from "../../HOC/withRouter";
import ExpandIconRound from "../../components/svgs/ExpandIconRound";
import { makeOppositeShade } from "../../utils/colorService";
import TPChallengeDoneIcon from "../../components/svgs/TPChallengeDoneIcon";

const TaskItems = ({ client, itemCompletion, itemsNames, gotoItem }) => {
  const [isVisible, setIsVisible] = useState(itemCompletion?.length < 2);

  if (!isVisible) {
    return (
      <div className="touchpoints-list">
        <span onClick={() => setIsVisible(true)}>
          <ExpandIconRound color={makeOppositeShade(client?.secondaryTextColor)} />
        </span>
      </div>
    );
  }

  return (
    <div className="touchpoints-list">
      <div className="touchpoints-buttons">
        {itemCompletion?.map(item => {
          const [id, progress] = Object.entries(item)[0];
          return (
            <>
              {itemsNames && itemsNames[id] && (
                <div key={id} className={`tp-button ${!progress ? "todo" : "done"}`} onClick={() => gotoItem(id)}>
                  <div className="tp-name">{itemsNames[id]}</div>
                  {!progress ? (
                    <svg xmlns="http://www.w3.org/2000/svg" width="8.168" height="8.164" viewBox="0 0 8.168 8.164">
                      <g id="Arrow-left-btn-white" transform="translate(0 0)">
                        <g id="up-arrow" transform="translate(8.168 0) rotate(90)">
                          <path
                            d="M0,4.078a4.082,4.082,0,1,1,4.082,4.08A4.08,4.08,0,0,1,0,4.078Zm.631,0A3.451,3.451,0,1,0,4.082.635,3.451,3.451,0,0,0,.631,4.078Zm4.812.883L4.082,3.607,2.724,4.961a.315.315,0,0,1-.444-.444L3.86,2.936a.317.317,0,0,1,.446,0L5.887,4.517a.314.314,0,0,1-.222.536A.308.308,0,0,1,5.443,4.961Z"
                            transform="translate(0 0)"
                            fill={makeOppositeShade(client?.secondaryTextColor)}
                          />
                        </g>
                      </g>
                    </svg>
                  ) : (
                    <TPChallengeDoneIcon color={client?.altColor} />
                  )}
                </div>
              )}
            </>
          );
        })}
      </div>
      {itemCompletion?.length > 1 && (
        <span onClick={() => setIsVisible(false)} className="minimize-icon">
          <ExpandIconRound color={makeOppositeShade(client?.secondaryTextColor)} />
        </span>
      )}
    </div>
  );
};

export default withRouter(TaskItems);
